import { render } from "./FormInputCprField.vue?vue&type=template&id=2b910ef0"
import script from "./FormInputCprField.vue?vue&type=script&lang=js"
export * from "./FormInputCprField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__